/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */

import React, { useEffect, useState } from 'react';
import { TextInput, PasswordInput } from '@carbon/react';
import { useTranslation } from 'react-i18next';

function TestToolUserCredentials({ userCreds, onChange }) {
  const { t } = useTranslation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    setUsername(userCreds.username ?? '');
    setPassword(userCreds.password ?? '');
  }, [userCreds.password, userCreds.username]);

  const handleUsernameChange = (event) => {
    const username = event.target.value;
    setUsername(event.target.value);
    if (onChange && typeof onChange === 'function') {
      onChange({ password, username });
    }
  };

  const handlePasswordChange = (event) => {
    const password = event.target.value;
    setPassword(event.target.value);
    if (onChange && typeof onChange === 'function') {
      onChange({ password, username });
    }
  };

  return (
    <div className="testToolUserCredentials">
      <div className="username">
        <div className="labelText">{t('username')}</div>
        <TextInput id="username" hideLabel labelText={t('username')} value={username} onChange={handleUsernameChange} />
      </div>

      <div className="password">
        <div className="labelText">{t('password')}</div>
        <PasswordInput id="password" labelText={t('password')} hideLabel value={password} onChange={handlePasswordChange} />
      </div>
    </div>
  );
}

export default TestToolUserCredentials;
